import React, { useState } from 'react';
import './App.css';
import './style.css';
import './font.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ArticleImageGalleryProvider } from './articleDetailPage/ArticleImageGallery';
import About from './PageAbout';
import Activities from './PageActivities';
import Works from './PageWorks';
import Work1 from './Work1NewAdsPlatformforExperts';
import Work2 from './Work2FirstUserProcessDesign';
import Work3 from './Work3StoreUXUIDesign';
import Work4 from './Work4LeadingMoreBusinessUserstoAdvertising';
import Work5 from './Work5NewServiceDesign';
import Work6 from './Work6OutlinkAds';
import Work7 from './Work7CatalogManager';
import Work8 from './Work8BiddingSystem';
import Work9 from './Work9NewVideoAds';
import Work10 from './Work10EliminatingConcernsofCreatingAds';
import Work11 from './Work11missionUX';
import Work13 from './Work13personalizedAdsConsent';
import Work15 from './Work15qrorder';
import Work16 from './Work16qrorderupdate';
import Article1 from './articles/Article1';
import Article2 from './articles/Article2';
import Article3 from './articles/Article3';
import Creative1 from './articles/creative1';
import PageToTop from './components/PageToTop';
import { PageViewTracker } from './components/PageViewTracker';
import Article4 from './articles/Article4';
import Creative2 from './articles/creative2';
import Creative3 from './articles/creative3';
import Article5 from './articles/Article5';
import Article6 from './articles/Article6';
import Essay2602 from './articles/Essay2602';
import Essay2601 from './articles/Essay2601';
import Book1 from './articles/book1';
import Book2 from './articles/book2';
import Essay2603 from './articles/Essay2603';
import Essay2604 from './articles/Essay2604';
import Essay2600 from './articles/Essay2600';
import Essay2605 from './articles/Essay2605';
import Essay2606 from './articles/Essay2606';
import Essay260601 from './articles/Essay260601';
import Essaytoyou from './articles/Essay260501';
import PageAboutHistory from './PageAboutHistory';
import PageViewLog from './PageViewLog';
import PageTodo from './PageTodo';
import PageDaily from './PageDaily';
import PageStudy from './PageStudy';
import PageEnglish from './PageEnglish';
import PageHideout from './PageHideout';
import RequireHideoutAuth from './components/RequireHideoutAuth';
import Essay2606_hiroshima from './articles/Essay2606_hiroshima';

function App() {
  const [activeNav, setActiveNav] = useState(3);
  
  return (
    <ThemeProvider>
    <LanguageProvider>
      <ArticleImageGalleryProvider>
      <div>
        <BrowserRouter>
        <PageToTop/>
        <PageViewTracker />
          <Routes>
            <Route path="/" element={<About activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/work" element={<Works activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/App" element={<Works activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/Web" element={<Works activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/2024" element={<Works activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/2023" element={<Works activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/2021" element={<Works activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Work1" element={<Work1 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>   
            <Route path="Work2" element={<Work2 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>   
            <Route path="Work3" element={<Work3 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>   
            <Route path="Work4" element={<Work4 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Work5" element={<Work5 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>   
            <Route path="Work6" element={<Work6 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>  
            <Route path="Work7" element={<Work7 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route> 
            <Route path="Work8" element={<Work8 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route> 
            <Route path="Work9" element={<Work9 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>  
            <Route path="Work10" element={<Work10 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>  
            <Route path="Work11" element={<Work11 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Work13" element={<Work13 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>   
            <Route path="Work15" element={<Work15 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Work16" element={<Work16 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Article1" element={<Article1 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>  
            <Route path="Article2" element={<Article2 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route> 
            <Route path="Article3" element={<Article3 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Article4" element={<Article4 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Article5" element={<Article5 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Article6" element={<Article6 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay2602" element={<Essay2602 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay2601" element={<Essay2601 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay2603" element={<Essay2603 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay2604" element={<Essay2604 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay2605" element={<Essay2605 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay2606" element={<Essay2606 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay260601" element={<Essay260601 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay_hiroshima" element={<Essay2606_hiroshima activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essay2600" element={<Essay2600 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="Essaytoyou" element={<Essaytoyou activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="AboutPastRecords" element={<PageAboutHistory activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="creative1" element={<Creative1 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="creative2" element={<Creative2 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="creative3" element={<Creative3 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="book1" element={<Book1 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="book2" element={<Book2 activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/life/*" element={<Activities activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/About/*" element={<About activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/log" element={<PageViewLog activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/todo" element={<RequireHideoutAuth><PageTodo activeNav={activeNav} setActiveNav={setActiveNav} /></RequireHideoutAuth>}></Route>
            <Route path="/daily" element={<RequireHideoutAuth><PageDaily activeNav={activeNav} setActiveNav={setActiveNav} /></RequireHideoutAuth>}></Route>
            <Route path="/study" element={<RequireHideoutAuth><PageStudy activeNav={activeNav} setActiveNav={setActiveNav} /></RequireHideoutAuth>}></Route>
            <Route path="/English" element={<PageEnglish activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
            <Route path="/hideout" element={<PageHideout activeNav={activeNav} setActiveNav={setActiveNav} />}></Route>
          </Routes>
        </BrowserRouter>
      </div>
      </ArticleImageGalleryProvider>
    </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
